export const selectProposalActivityEvents = (state) => state.proposals.activity.events;

export const selectProposalActivityIsLoading = (state) => state.proposals.activity.isLoading;

export const selectProposalActivityError = (state) => state.proposals.activity.error;

export const selectProposalActivitySearch = (state) => state.proposals.activity.search;

export const selectProposalActivityFilteredEvents = (state) => {
  const term = state.proposals.activity.search.trim().toLowerCase();
  const events = state.proposals.activity.events;
  if (!term) {
    return events;
  }
  return events.filter((e) => {
    const haystack = `${e.userName} ${e.item} ${e.description}`.toLowerCase();
    return haystack.includes(term);
  });
};

export const selectProposalActivityTotal = (state) =>
  state.proposals.activity.events.length;

export const selectProposalActivityFilteredTotal = (state) =>
  selectProposalActivityFilteredEvents(state).length;
